import Vue from 'vue'
import VueRouter from 'vue-router'
import NoticeRouter from '../views/noticePractise'
import calcPractise from '../views/calcPractise2'
import TestRouter from '../views/test'
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        name: 'Login',
        component: NoticeRouter
    },
    {
        path: '/notice',
        name: 'notice',
        component: NoticeRouter
    },
    {
        path: '/calc',
        name: '计算练习',
        component: calcPractise
    },
    {
        path: '/test',
        name: '测试',
        component: TestRouter
    }
]
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router